<template>
  <div class="row">
    <div class="col-lg-5 col-md-8 col-sm-12">
      <h2>
        <a
          href="javascript:void(0);"
          class="btn btn-xs btn-link btn-toggle-fullwidth"
          v-if="!isRootDashboard"
        >
          <i class="fa fa-arrow-left" @click="$router.back()"></i>
        </a>
        {{ meta }}
      </h2>
      <ul class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link to="/dashboard"><i class="icon-home"></i></router-link>
        </li>
        <li
          class="breadcrumb-item"
          v-for="item in crumbs"
          :key="item.path"
        >
          {{ item.text }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    isRootDashboard() {
    return this.$route.path === "/dashboard";
  },
    crumbs: function() {
      let pathArray = this.$route.path.split("/")
      pathArray.shift()
      let breadcrumbs = pathArray.reduce((breadcrumbArray, path, idx) => {
        const routeMeta = this.$route.matched[idx] ? this.$route.matched[idx].meta : {};

        breadcrumbArray.push({
        path: path,
          to: breadcrumbArray[idx - 1]
            ? "/" + breadcrumbArray[idx - 1].path + "/" + path
            : "/" + path,
            text: routeMeta.breadCrumb || path,
        });
        
        return breadcrumbArray;
      }, [])
      return breadcrumbs;
    }
  },
  methods:{
        layoutFullwidth(){
            this.show = !this.show;
            let sitebody = document.body;
            this.show ? sitebody.classList.add("layout-fullwidth") : sitebody.classList.remove("layout-fullwidth");
        },
        visitorsOptionsSeries() {
            return this.data = [3,5,1,6,5,4,8,3]
        },
         visitOptionsSeries() {
            return this.data = [4,6,3,2,5]
        },
    }, data (){
        return {
            show:false,
            meta:'',
            visitors: {
                grid: {
                    left: 0,
                    top: 0,
                    right: 0,
                    bottom: 0
                },
                tooltip : {
                    trigger: 'item',
                    formatter:function(params){
                        var param = params;
                        return param.marker+" "+param.value;
                    }
                },
                xAxis: {
                    type: 'category',
                    show: false,
                    boundaryGap: false,
                },
                yAxis : [
                    {
                        type : 'value',
                        show:false,
                    }
                ],
                series: [
                    {
                        type: 'line',
                        symbolSize: 1,
                        showSymbol: true,
                        data: this.visitorsOptionsSeries(),
                        lineStyle: {
                            width: 1,
                        },
                    }
                ],
                color: ["#00c5dc"]
            },
            visit: {
                grid: {
                    left: 0,
                    top: 0,
                    right: 0,
                    bottom: 0
                },
                tooltip : {
                    trigger: 'item',
                    formatter:function(params){
                        var param = params;
                        return param.marker+" "+param.value;
                    }
                },
                xAxis: {
                    type: 'category',
                    show: false,
                    boundaryGap: false,
                },
                yAxis : [
                    {
                        type : 'value',
                        show:false,
                    }
                ],
                series: [
                    {
                        type: 'line',
                        symbolSize: 1,
                        showSymbol: true,
                        data: this.visitOptionsSeries(),
                        lineStyle: {
                            width: 1,
                        },
                    }
                ],
                color: ["#f4516c"]
            },
        }
    },created() {
        console.log(this.$route);
        if(this.$route.meta.title){
          this.meta = this.$route.meta.title; 
        }else{
            this.meta = this.$route.matched[0].meta.breadCrumb;   
        }
        
    }
};
</script>
<style scoped>
.echart-line-chart{
    height: 20px;
    width: 112px;
}
</style>